import React, { useState } from 'react'
import ModalBody from './modal/modal-body'
import { MaterialSymbolsConnectWithoutContact } from './icons/get-intouch'
import TDImage from '@/assets/images/18.png'

type Props = {}

const InTouch = (props: Props) => {
  const [sent, setSent] = useState<boolean>(false)
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  })

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    setSent(true)
  }

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target
    setFormData(prev => ({
      ...prev,
      [name]: value
    }))
  }

  return (
    <ModalBody>
      <div className='flex flex-col items-center w-full justify-center gap-y-6  mx-auto'>
        <div className='flex items-center gap-x-2 text-blue-500'>
          <MaterialSymbolsConnectWithoutContact width={24} height={24} />
          <h1 className='text-lg md:text-xl font-bold'>Get In Touch</h1>
        </div>
        <img src={TDImage} alt='image' className='w-1/2 rounded-lg'/>
        {sent && 
          <div className='bg-green-700/25 text-green-600 w-full p-2 text-center rounded-lg'>
            <span>Your message has been sent!</span>
          </div>
        }
        <form onSubmit={handleSubmit} action={"https://formsubmit.co/xams.noreply@gmail.com"} method='POST' className='w-full space-y-4'>
          <div className='space-y-2'>
            <label htmlFor="name" className='text-xs md:text-sm text-gray-400'>Name</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              className='w-full px-3 md:px-4 py-2 bg-black border border-blue-500/15 rounded-lg focus:outline-none focus:border-blue-500 text-white text-sm md:text-base'
              required
            />
          </div>

          <div className='space-y-2'>
            <label htmlFor="email" className='text-xs md:text-sm text-gray-400'>Email</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className='w-full px-3 md:px-4 py-2 bg-black border border-blue-500/15 rounded-lg focus:outline-none focus:border-blue-500 text-white text-sm md:text-base'
              required
            />
          </div>

          <div className='space-y-2'>
            <label htmlFor="message" className='text-xs md:text-sm text-gray-400'>Message</label>
            <textarea
              id="message"
              name="message"
              value={formData.message}
              onChange={handleChange}
              rows={4}
              className='w-full px-3 md:px-4 py-2 bg-black border border-blue-500/15 rounded-lg focus:outline-none focus:border-blue-500 text-white text-sm md:text-base resize-none'
              required
            />
          </div>

          <button
            type="submit"
            className='w-full cursor-pointer py-2 px-4 bg-blue-500/15 hover:bg-blue-500/25 text-blue-500 rounded-lg transition-colors duration-300 font-medium text-sm md:text-base'
          >
            Send Message
          </button>
        </form>
      </div>
    </ModalBody>
  )
}

export default InTouch